<template>
  <div>
    <Drawer v-model="logsDrawer" width="550">
      <OperateLogs ref="OperateLogs" :logs="logs"></OperateLogs>
    </Drawer>
    <Card shadow>
      <Row class="sm-pc-w100">
        <Col :md="22">
          <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="50" @submit.native.prevent>
            <FormItem label="名称">
              <Input v-model="tableSearchForm.name" style="width: 200px" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="2" class="align-right">
          <Button
            style="float: right;"
            @click="$router.push({name: 'tools_node_add'})"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">添加节点</Button>
        </Col>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getNodes, deleteNode } from '@/api/tools/gitlab'
import OperateLogs from './operateLogs'
import moment from 'moment'

export default {
  name: 'list',
  components: {
    OperateLogs
  },
  data () {
    return {
      tableLoading: false,
      tableSearchForm: {
        name: ''
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: 'URL',
            key: 'url',
            align: 'center',
            tooltip: true,
            minWidth: 250
          },
          {
            title: '类型',
            key: 'type',
            align: 'center',
            tooltip: true,
            minWidth: 250
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 200,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.logs = params.row.logs
                      this.logsDrawer = true
                    }
                  }
                }, '日志'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'tools_node_edit', params: {id: params.row.id}})
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      listError: false,
      moment: moment,
      logsDrawer: false,
      logs: []
    }
  },
  mounted: function () {
    this.getTableData()
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      getNodes(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: ''
      }
    },
    delete (id) {
      deleteNode(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
